import classNames from "classnames";
let buildings = require("../../config/all-buildings.json")

let upgradePBGID = require("../../config/ageUpUpgrades.json")
let allTechs = require("../../config/all-unified-techs.json")

function getDataByPgbid(pgbid) {
    const resultArray = buildings.flatMap(item =>
        item.variations.map(variation => ({
            pbgid: variation.pbgid,
            name: item.name,
            icon: item.icon
        }))
    );

    return resultArray.find(item => item.pbgid === pgbid) || null;
}

//TODO Update this since its a copy of LiveGameAgeUpAsUpgrade
function getUpgradeDataByPgbid(pgbid) {
    let data = upgradePBGID.find(item => item.pbg_id.includes(pgbid)) || null;
    // need to do this since we are mutating the objecft
    let object = { ...data };
    let extraData = findByPbgidWithKey(pgbid);

    if (object && !object.displayName) {
        object.icon = extraData?.icon
        object.displayName = extraData?.key?.match(/wing-(.*)/)?.[1]?.replace('-', ' ').replace(/\b\w/g, c => c.toUpperCase()) || extraData?.key?.replaceAll('-', ' ').replace(/\b\w/g, c => c.toUpperCase())
    }

    return object;
}

function findByPbgidWithKey(targetId) {
    for (let [key, arr] of Object.entries(allTechs)) {
        let found = arr.find(item => String(item.pbgid) === String(targetId));
        if (found) return { key, ...found };
    }
    return null;
}

export function LiveGameLandmarkDisplay({ pbgid, count, inQueue, isUnique = false, leftSide, showCount = true, isKT = false }) {
    const data = getDataByPgbid(pbgid) || getUpgradeDataByPgbid(parseInt(pbgid))
    console.log(isKT)

    return (
        <div className={classNames("h-[40px] flex", isKT ? 'w-[74px] ' : 'w-[40px] ', leftSide ? "flex-row-reverse" : "flex-row")}>
            {showCount &&
            <div className="w-[30px] bg-[#252525dc] flex flex-col">
                <h1 className={classNames("h-5 px-1 text-[#b1b1b1] align-top -mt-[2px] italic", leftSide ? "text-left" : "text-right", inQueue === 0 ? "opacity-0" : "")} style={{textShadow: '2px 2px 3px black'}}>{inQueue}</h1>
                <h1 className={classNames("h-5 px-1 text-white align-top -mt-[2px] ", leftSide ? "text-left" : "text-right")} style={{textShadow: '2px 2px 3px black'}}>{count}</h1>
            </div>
            }
            <div className={classNames("relative", isKT ? 'w-[74px]' : "w-[40px] ")} style={{backgroundImage: `url(/liveGameIcons/empty_background.png)`}}>
                <img className={classNames("h-10", isKT ? 'w-[74px]' : 'w-10')} src={data?.icon} alt="" />
                {isUnique && <img className="absolute bottom-0 left-0 w-4 h-4" src={`/liveGameIcons/unique.png`} alt="" />}
            </div>
        </div>
    );
}
